import { Injectable, computed, signal } from '@angular/core';

export interface Message {
    eventName?: string;
    eventData?: any;
}

@Injectable({
    providedIn: 'root',
})
export class BetslipQdMessageService {
    private inputQueue: Message[] = [];
    private outputQueue: Message[] = [];

    private inputSignal = signal<Message>({});
    private outputSignal = signal<Message>({});

    private inputProcessing = false;
    private outputProcessing = false;

    readonly input = computed(() => this.inputSignal());
    readonly output = computed(() => this.outputSignal());

    sendInput(message: Message) {
        this.inputQueue.push(message);
        this.processNextInput();
    }

    sendOutput(message: Message) {
        this.outputQueue.push(message);
        this.processNextOutput();
    }

    private processNextInput() {
        if (this.inputProcessing || this.inputQueue.length === 0) return;

        this.inputProcessing = true;
        const nextMessage = this.inputQueue.shift();
        if (nextMessage) {
            this.inputSignal.set(nextMessage);
        }

        setTimeout(() => {
            this.inputProcessing = false;
            this.processNextInput();
        }, 100);
    }

    private processNextOutput() {
        if (this.outputProcessing || this.outputQueue.length === 0) return;

        this.outputProcessing = true;
        const nextMessage = this.outputQueue.shift();
        if (nextMessage) {
            this.outputSignal.set(nextMessage);
        }

        setTimeout(() => {
            this.outputProcessing = false;
            this.processNextOutput();
        }, 100);
    }

    /** Fully clears all data and resets signals */
    destroy() {
        this.inputQueue = [];
        this.outputQueue = [];
        this.inputSignal.set({});
        this.outputSignal.set({});
    }
}
